import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ProductTypes } from "src/app/shared/product/productTypes";
import { environment } from "src/environments/environment";
import { Product } from "../../../../buyer";
import { ProductsCatalogService } from "../../../../services/products-catalog.service";
import { ViewProductInfoHandlerService } from "../../../../services/view-product-info-handler.service";

@Component({
  selector: 'app-seller-view',
  templateUrl: './seller-view.component.html',
  styleUrls: ['./seller-view.component.scss']
})
export class SellerViewComponent implements OnInit {
  _products: Product[] = [];
  @Input() products: Product[] = [];
  @Input() businessData: any;
  businessName: string = '';
  businessDescription: string = '';
  businessLogo: string = '';
  currentStart: number = 0;
  stopPagination: boolean = false;
  paginationHappening: boolean = false;
  pageSize: number = 12;
  facebookbtns = ["facebook"];
  twitterbtns = ["twitter"];
  linkedInbtns = ["linkedin"];
  facebookLink: string = '';
  twitterLink: string = '';
  linkedInLink: string = '';
  btnsSize: number = -4;
  noProducts: boolean = false;

  constructor(
    private vpihs: ViewProductInfoHandlerService,
    private productCatalogService: ProductsCatalogService,
    private router: Router,
  ) { }

  async ngOnInit() {
    this.facebookLink = this.businessData?.link_fb;
    this.twitterLink = this.businessData?.link_tw;
    this.linkedInLink = this.businessData?.link_li;
    if (!this.vpihs.exchangeRates) {
      await this.vpihs.getExchangeRates();
    }
    this.setProducts();
    try {
      if (this.products && this.products.length) {
        this.currentStart = this.products.length;
        if (this.currentStart < this.pageSize) {
          this.stopPagination = true;
        }
      } else {
        this.noProducts = true;
        this.stopPagination = true;
      }
    } catch (err) {
      console.log(err);
      this.router.navigate(["/"]);
    }
  }

  setProducts() {
    this._products = this.products.map((product: any) => {
      switch (product.productType) {
        case "Event":
          product.productType = "Event";
          break;
          case "Reservation":
          product.productType = ProductTypes.Reservation;
          break;
        case "Physical Product":
          product.productType = "Product";
          break;
        case "Invoice":
          product.productType = "Invoice";
          break;
      }
      if (product.productPrice) {
        product.productPrice = this.vpihs
          .getExchangedValue(+product.productPrice, product.currency)
          .toFixed();
      }
      if (!product.image) {
        product.image = 'assets/images/placeholders/invoice.jpg';
      }
      return product;
    });
  }

  async openProduct(code: any) {
    window.location.href = environment.BASE_URL + code
  }

  async loadMore() {
    this.pageSize += 12;
    this.productCatalogService.setParams({
      businessName: this.businessData?.name,
      start: this.currentStart,
      limit: this.pageSize
    });
    try {
      const paginationResponse = await this.productCatalogService.make();
      if (
        !paginationResponse ||
        !paginationResponse.products ||
        !paginationResponse.products.length
      ) {
        this.stopPagination = true;
      } else if (paginationResponse.products.length < this.pageSize) {
        this.products = [...this.products, ...paginationResponse.products];
        this.currentStart = this.products.length;
        this.stopPagination = true;
      } else {
        this.products = [...this.products, ...paginationResponse.products];
        this.currentStart = this.products.length;
      }
    } catch (err) {
      this.stopPagination = true;
    }
    this.paginationHappening = false;
  }
}
